import {
  DRAGGABLE_TYPES,
  OverlayItem,
  OverlayItemAssigned,
  OverlayItemUnassigned,
  OverlayItemWithImage,
  OverlayItemWithVideo,
  SegmentItem,
  SegmentItemAssigned,
  type TimelineItem,
  TimelineItemAssigned
} from '@/redux/slices/packagingSlice.types';

export const isSegment = (segmentOrOverlay: TimelineItem): segmentOrOverlay is SegmentItem => {
  return segmentOrOverlay.type === DRAGGABLE_TYPES.SEGMENT;
};

export const isAssignedSegment = (segment: SegmentItem): segment is SegmentItemAssigned => {
  return Boolean(segment.source?.titleId);
};

export const isOverlayWithAssignedVideo = (overlay: OverlayItem): overlay is OverlayItemWithVideo => {
  return (overlay as OverlayItemWithVideo).sourceType === 'video';
};

export const isOverlayWithAssignedImage = (overlay: OverlayItem): overlay is OverlayItemWithImage => {
  return (overlay as OverlayItemWithImage).sourceType === 'image';
};

export const isUnassignedOverlay = (overlay: OverlayItem): overlay is OverlayItemUnassigned => {
  return !(overlay as any).sourceType;
};

export const isAssignedOverlay = (overlay: OverlayItem): overlay is OverlayItemAssigned => {
  return !!(overlay as any).sourceType;
};

export const isTimelineItemAssigned = (item: TimelineItem): item is TimelineItemAssigned => {
  return isSegment(item) ? isAssignedSegment(item) : isAssignedOverlay(item);
};
